import { useEffect, useState } from 'react';
import { readRecovery, saveRecovery } from './draftRecovery';

export function useDraftRecovery(
  owner: string,
  enabled: boolean,
  value: string,
  restore: (text: string) => void,
) {
  const [record, setRecord] = useState(() => ({
    owner,
    text: enabled ? readRecovery(owner) : null,
  }));
  if (record.owner !== owner) setRecord({ owner, text: enabled ? readRecovery(owner) : null });
  useEffect(() => {
    if (enabled && record.owner === owner && !record.text) saveRecovery(owner, value);
  }, [enabled, owner, record, value]);
  return {
    pending: record.owner === owner ? record.text : null,
    restore() {
      if (record.text) restore(record.text);
      setRecord({ owner, text: null });
    },
    discard() {
      saveRecovery(owner, '');
      setRecord({ owner, text: null });
    },
  };
}
